// Readout formatting for the instrument panels.

// 83_450 → "1:23.4". Tenths, because the warn cue and the cap are seconds
// apart and a whole-second clock looks frozen.
export const clock = (ms: number): string => {
  const clamped = Math.max(0, ms);
  const minutes = Math.floor(clamped / 60_000);
  const seconds = Math.floor((clamped % 60_000) / 1000);
  const tenths = Math.floor((clamped % 1000) / 100);
  return `${String(minutes)}:${String(seconds).padStart(2, "0")}.${String(tenths)}`;
};

export const bytes = (n: number): string =>
  n < 1024
    ? `${String(n)} B`
    : n < 1024 * 1024
      ? `${(n / 1024).toFixed(1)} KiB`
      : `${(n / (1024 * 1024)).toFixed(2)} MiB`;
